import { AccountWithExtraInfo } from '@orbis-systems/orbis-api-middleware';
import { QueryClient } from '@tanstack/react-query';

import { combineAccountsWithRtbs, formatPortfolio, getPortfolioSecurityTotalValue } from './adapters';
import { branchQueries } from './queries';
import { combinePositions } from './combinePositions';
import { userQueries } from '../user';

export const buildBranchPortfolioWithBreakdownFromCache =
    ({ currency }: { currency: string }) =>
    ({ client }: { client: QueryClient }) => {
        const branchPortfolio = client.getQueryData(
            branchQueries.branchPortfolio({ currency, combined: false }).queryKey,
        )?.data;
        const userInformation = client.getQueryData(userQueries.userInformation().queryKey)?.data;
        const branchRtbs = client.getQueryData(branchQueries.branchRtbs().queryKey)?.data;
        const branchInventory = client.getQueryData(branchQueries.branchInventory().queryKey)?.data;
        if (branchPortfolio && userInformation && branchRtbs && branchInventory) {
            client.removeQueries({
                type: 'inactive',
                queryKey: [...branchQueries.all().queryKey, 'branchPortfolioWithBreakdown'],
            });
            const { entries: positions, ...restPortfolio } = branchPortfolio;
            const accountsWithRtbs = combineAccountsWithRtbs(
                [...branchInventory, ...userInformation.accountList],
                branchRtbs,
            );
            const combinedPositions = combinePositions(positions);
            const securityTotalValue = getPortfolioSecurityTotalValue(positions);
            const portfolioWithCombinedPositions = {
                ...restPortfolio,
                entries: combinedPositions,
                currency,
                securityTotalValue,
            };
            const portfolio = formatPortfolio(
                portfolioWithCombinedPositions,
                accountsWithRtbs,
                branchInventory,
                securityTotalValue,
            );
            const accountMap = accountsWithRtbs.reduce<Record<number, AccountWithExtraInfo>>((acc, account) => {
                acc[account.accountId] = account;
                return acc;
            }, {});
            return { portfolio, accountMap };
        } else throw new Error('branchPortfolioWithBreakdown: expected source queries populated');
    };
